import InherentRisksSidePanel from './InherentRisksSidePanel';
export default InherentRisksSidePanel;
